// eslint-disable-next-line no-unused-vars
class indexDbCC {
    constructor(tableName = 'defaultTable', dbVersion = 1) {
        this.dbName = 'MYDATABASE';
        this.dbVersion = dbVersion;
        this.dbtableName = tableName;
        this.dbRequest = null;
        this.db = null;
    }

    initDb() {
        let that = this;
        return new Promise((resolve, reject) => {
            if (window.indexedDB) {
                that.dbRequest = window.indexedDB.open(that.dbName, that.dbVersion);
            }
            this.dbRequest.onerror = function () {
                console.log('数据库打开报错');
                reject('error');
            };
            this.dbRequest.onsuccess = function () {
                that.db = that.dbRequest.result;
                resolve('success');
                console.log('数据库打开成功');
            };
            this.dbRequest.onupgradeneeded = function (e) {
                that.db = e.target.result;
                resolve('upgradeneeded');
                console.log('版本不对应时触发');
            };
        });
    }

    //关闭数据库
    closeDataBase() {
        if (this.db != null) {
            this.db.close();
            this.db = null;
            console.log('数据库关闭');
        }
    }

    // 删除数据库
    clearDataBase() {
        let request = this.db.deleteDatabase(this.dbName);
        request.onsuccess = e => {
            console.log('数据库删除成功', e);
        };
        request.onerror = e => {
            console.log('数据库删除失败', e);
        };
    }

    //添加表与字段
    addTable(columns) {
        // 结构:[['name', 'name', { unique: false }],['name', 'name', { unique: false }]]
        let objectStore = null;
        if (!this.db.objectStoreNames.contains(this.dbtableName)) {
            objectStore = this.db.createObjectStore(this.dbtableName, { keyPath: 'id', autoIncrement: true });
            columns.forEach((item) => {
                objectStore.createIndex(...item);
            });
        }
    }

    //添加数据
    addStore(columnval) {
        let that = this;
        return new Promise((resolve, reject) => {
            let request = that.db.transaction([this.dbtableName], 'readwrite')
                .objectStore(this.dbtableName)
                .add(columnval);

            request.onsuccess = function () {
                console.log('数据写入成功');
                resolve('success');
            };

            request.onerror = function () {
                console.log('数据写入失败');
                reject();
            };
        });
    }

    //获取全部数据
    getAllData() {
        return new Promise((resolve, reject) => {
            let transaction = this.db.transaction([this.dbtableName]);
            let objectStore = transaction.objectStore(this.dbtableName);
            let request = objectStore.getAll();

            request.onerror = function () {
                console.log('事务失败');
                reject();
            };

            request.onsuccess = function () {
                resolve(request.result);
                if (request.result) {
                    resolve(request.result);
                } else {
                    console.log('未获得数据记录');
                }
            };
        });
    }

    //
    getAllDataByModelId(modelId) {
        return new Promise((resolve, reject) => {
            let transaction = this.db.transaction([this.dbtableName]);
            let objectStore = transaction.objectStore(this.dbtableName);
            let request = objectStore.index('modelId').getAll(modelId);

            request.onerror = function () {
                console.log('事务失败');
                reject();
            };

            request.onsuccess = function () {
                resolve(request.result);
                if (request.result) {
                    resolve(request.result.reverse());
                } else {
                    console.log('未获得数据记录');
                }
            };
        });
    }

    /**
     * 根据索引值查询
     * index 索引
     * dataStr 索引内容
     * */
    getDataByIndex(index, dataStr) {
        return new Promise((resolve, reject) => {
            let transaction = this.db.transaction([this.dbtableName]);
            let objectStore = transaction.objectStore(this.dbtableName);
            let request = objectStore.index(index).getAll(dataStr);

            request.onerror = function () {
                console.log('事务失败');
                reject();
            };

            request.onsuccess = function () {
                resolve(request.result);
                if (request.result) {
                    resolve(request.result);
                } else {
                    console.log('未获得数据记录');
                }
            };
        });
    }

    /**
     * 更新数据
     * */
    updateData(columnVal) {
        // 结构:{id: 1, name: '李四', age: 35, email: 'lisi@example.com'}
        return new Promise((resolve, reject) => {
            let request = this.db.transaction([this.dbtableName], 'readwrite')
                .objectStore(this.dbtableName)
                .put(columnVal);

            request.onsuccess = function () {
                console.log('数据更新成功');
                resolve();
            };

            request.onerror = function () {
                console.log('数据更新失败');
                reject();
            };
        });
    }

    /**
     * 根据id删除
     * */
    remove(delId) {
        return new Promise((resolve) => {
            let request = this.db.transaction([this.dbtableName], 'readwrite')
                .objectStore(this.dbtableName)
                .delete(delId);

            request.onsuccess = function () {
                console.log('数据删除成功');
                resolve();
            };
        });
    }

    /**
     * indexDb 存储自动填充数据
     * */
    saveAutoFillData(modelId, content, search) {
        this.getAllDataByModelId(modelId).then((res) => {
            console.log('indexedDb', res);
            let delIndexs = [];//记录需要删除的
            res.forEach((itemA) => {
                let tableContent = itemA.content;
                let searchLen = 0;
                let primaryIndex = 0;
                //存在主键
                for (let key in search) {
                    searchLen++;
                    //主键内容都相同时删除记录
                    if (tableContent[key] === search[key]) {
                        primaryIndex++;
                    }
                }
                if ((searchLen !== 0 && primaryIndex === searchLen)) {
                    delIndexs.push(itemA.id);
                }
            });
            delIndexs.forEach((m) => {
                this.remove(m).then(() => {
                    console.log('删除成功');
                });
            });
            if (modelId) {
                this.addStore({ modelId: modelId, content: content, created_time: new Date().getTime() }).then(() => {
                    console.log('添加成功！');
                });
            }
        });
    }
}

// eslint-disable-next-line new-cap
let obj = new indexDbCC('auto_write_record', 1);
obj.initDb().then((res) => {
    if (res === 'upgradeneeded') {
        obj.addTable([['modelId', 'modelId', { unique: false }],
            ['content', 'content', { unique: false }],
            ['created_time', 'created_time', { unique: false }]]);
    }
    // obj.addStore({modelId:'model1',content:'yang',created_time:'male'}).then(()=>{
    //     obj.getAllData().then(res=>{
    //         console.log(res);
    //     });
    // })
    // obj.updateData({id: 1, name: '张三', age: 35, email: 'lisi@example.com'});
    // obj.updateData({id: 1, name: '张三', age: 35, email: 'lisi@example.com'});
    // obj.updateData({id: 1, name: '赵六', age: 35, email: 'lisi@example.com'});
    // obj.updateData({id: 1, name: '王五', age: 35, email: 'lisi@example.com'});
    // obj.remove(1).then(()=>{
    //     console.log("删除成功！");
    // });
});

export default obj;
